import { render, staticRenderFns } from "./SettingIndex.vue?vue&type=template&id=f77aa002"
import script from "./SettingIndex.vue?vue&type=script&lang=js"
export * from "./SettingIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports